import type { ReactNode } from 'react';
import { HeaderNav } from './Nav';
import '../styles/header.scss';

/**
 * The header renders on every screen including an active AppStream session, so
 * `children` is where a screen puts controls that belong beside the account
 * menu — the session name and its exit button, in the streaming case.
 */
export function Header({ children }: { children?: ReactNode }) {
  return (
    <header className="x5-header">
      <HeaderNav>{children}</HeaderNav>
    </header>
  );
}
